import type {
  FieldKey,
  SelectedByField,
} from '@app/components/Modals/CombineClientsModal/types';

export const initialSelectedByField: SelectedByField = {
  ClientName: null,
  Phone: null,
  Email: null,
  VK: null,
  Telegram: null,
  Instagram: null,
  Tags: null,
};

export const PF = 'combine-clients-modal';

export const SELECTABLE_FIELDS: Array<{
  key: FieldKey;
  label: string;
}> = [
  { key: 'ClientName', label: 'ФИО' },
  { key: 'Phone', label: 'Телефон' },
  { key: 'Email', label: 'Email' },
  { key: 'VK', label: 'VK' },
  { key: 'Telegram', label: 'Telegram' },
  { key: 'Instagram', label: 'Instagram' },
  { key: 'Tags', label: 'Теги' },
];

export const STAT_FIELDS: Array<{
  key: 'RecordsCount' | 'SalesCount';
  label: string;
}> = [
  { key: 'RecordsCount', label: 'Записи' },
  { key: 'SalesCount', label: 'Продажи' },
];
